import type { Tile } from "./generals-board-model";
import {
  boardTile,
  simulationIndex,
  simulationNeighbors,
  type GridPosition,
} from "./generals-board-grid";

export function simulationDestination({
  tiles,
  src,
  x,
  y,
}: {
  readonly tiles: readonly Tile[];
  readonly src: Tile;
  readonly x: number;
  readonly y: number;
}): Tile | undefined {
  const open = simulationNeighbors({ x, y }).filter(
    ({ x: nx, y: ny }) =>
      !boardTile({ tiles, index: simulationIndex({ x: nx, y: ny }) }).mountain,
  );

  if (!open.length) return undefined;

  const neutrals = open.filter(
    ({ x: nx, y: ny }) =>
      boardTile({ tiles, index: simulationIndex({ x: nx, y: ny }) }).owner ===
      -1,
  );
  const enemies = open.filter(({ x: nx, y: ny }) => {
    const n = boardTile({ tiles, index: simulationIndex({ x: nx, y: ny }) });
    return n.owner !== -1 && n.owner !== src.owner;
  });
  let target: GridPosition | undefined;

  if (neutrals.length && (!enemies.length || Math.random() < 0.75)) {
    target = neutrals[Math.floor(Math.random() * neutrals.length)];
  } else if (enemies.length) {
    target = enemies[Math.floor(Math.random() * enemies.length)];
  } else return undefined;

  if (!target) throw new RangeError("Simulation destination is out of bounds");

  return boardTile({ tiles, index: simulationIndex(target) });
}
export function resolveSimulationMove({
  src,
  dst,
}: {
  readonly src: Tile;
  readonly dst: Tile;
}): boolean {
  let generalFell = false;
  const moving = src.count - 1;
  src.count = 1;

  if (dst.owner === -1) {
    dst.owner = src.owner;
    dst.count = moving;
  } else if (dst.owner === src.owner) {
    dst.count += moving;
  } else if (moving > dst.count) {
    if (dst.general) generalFell = true;

    dst.count = moving - dst.count;
    dst.owner = src.owner;
  } else {
    dst.count -= moving;
  }

  return generalFell;
}
